import { api } from "@portal/arq-portal-core";
import { User } from "../models/User";
import { UserNode } from "../models/UserNode"

const server = api.getApiServer();
const getProfileImageUrl = (userCode: string, employeeNumber: string) => {
    const profileId = employeeNumber ?? userCode;
    return `${server}/UserImage/${profileId}/`;
}
const getTags = (user: User): string[] => {
    const result = [];

    switch (user.EmployeeType) {
        case 1:
            result.push("NotRepeated");
            break;
        case 2:
            result.push("Repeated");
            break;
        case 3:
            result.push("assistant");
            break;
        default:
            break;
    }
    return result;
}

export const userAdapter = {
    adaptToUserNode: (user: User): UserNode => {
        const isRepeated = user.EmployeeType == 2;
        return {
            id: user.Id,
            pid: user.ParentId,
            img: getProfileImageUrl(user.UserCode, user.EmployeeNumber),
            tags: getTags(user),
            Nombre: isRepeated ? '(' + user.Name + ')' : user.Name,
            // Rol: user.Role,
            'Dirección': user.Address,
            Compañía: user.Company,
            Email: user.Email,
            'Número de empleado': user.EmployeeNumber,
            'Ubicación Oficina': user.Facility,
            // Fax: user.Fax,
            'Código INFO': user.Info,
            // 'Descripción del puesto': user.InfoDescription,
            // 'Nombre del superior': user.ManagerName,
            Móvil: user.Mobile,
            // 'Url del perfil': user.ProfileUrl,
            'Descripción del rol': user.RoleDescription,
            Teléfono: user.Telf
        };
    }
}

